import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatPageTitle } from '../app/page-title';

export function NotFoundPage() {
  useEffect(() => {
    document.title = formatPageTitle('Page unavailable');
  }, []);

  return (
    <main className="standalone">
      <h1>Page unavailable</h1>
      <p>The requested page does not exist or could not be loaded.</p>
      <Link to="/">Return to dashboard</Link>
    </main>
  );
}
